import moment from 'moment';
import { useState, ComponentProps } from 'react';
import { useMedia } from 'react-use';
import { IMaskMixin } from 'react-imask';
import { Fragment } from 'react';
import {
  IonInput,
  IonButton,
  IonIcon,
  IonModal,
  IonDatetime,
} from '@ionic/react';
import classNames from 'classnames';
import { useContext, useContextSelector } from 'use-context-selector';

import { ICONS_BASE64 } from '../../../Icon';
import { FormDatepickerContext } from '../FormDatepicker.context';
import { MAX_DATE, MIN_DATE, VALUE_DATE_FORMAT } from '../FormDatepicker.const';
import { LocalizationContext } from '../../../../contexts/LocalizationContext';

import input from '../../_styles/input.module.scss';
import styles from './FormDatepickerMaskedInput.module.scss';

type OnDatetimeChange = ComponentProps<typeof IonDatetime>['onIonChange'];

export const FormDatepickerMaskedInput = IMaskMixin<HTMLIonInputElement>(
  ({ inputRef, label }) => {
    const isMobile = useMedia('(max-width: 480px)');

    const [isOpen, setIsOpen] = useState(false);

    const datepicker = useContextSelector(
      LocalizationContext,
      ({ form: { datepicker } }) => datepicker
    );

    const {
      id,
      error,
      value,
      onBlur,
      invalid,
      onChange,
      placeholder,
      enterKeyHint,
      defaultValue,
    } = useContext(FormDatepickerContext);

    const datetime = (() => {
      if (value) {
        return moment(value).utc(true).toISOString();
      }
      return moment(defaultValue).utc(true).toISOString();
    })();

    const handleOnDatetimeChange: OnDatetimeChange = ({
      detail: { value },
    }) => {
      onChange(moment(value).format(VALUE_DATE_FORMAT));
    };

    return (
      <Fragment>
        <IonInput
          fill="outline"
          label={label}
          ref={inputRef}
          onIonBlur={onBlur}
          labelPlacement="stacked"
          errorText={error?.message}
          enterkeyhint={enterKeyHint}
          placeholder={placeholder || datepicker.format}
          className={classNames(input.root, {
            'ion-invalid': invalid,
            'ion-touched': invalid,
          })}
        >
          <IonButton
            slot="end"
            fill="clear"
            size="small"
            aria-label="Show/hide"
            className={styles.button}
            onClick={() => setIsOpen(true)}
          >
            <IonIcon
              slot="icon-only"
              icon={ICONS_BASE64.calendar}
              aria-hidden="true"
            />
          </IonButton>
        </IonInput>
        <IonModal
          isOpen={isOpen}
          keepContentsMounted={true}
          onDidDismiss={() => setIsOpen(false)}
        >
          <IonDatetime
            id={id}
            min={MIN_DATE}
            max={MAX_DATE}
            value={datetime}
            showDefaultButtons
            presentation="date"
            preferWheel={isMobile}
            locale={datepicker.locale}
            onIonChange={handleOnDatetimeChange}
            doneText={datepicker.buttons.confirm}
            cancelText={datepicker.buttons.cancel}
          ></IonDatetime>
        </IonModal>
      </Fragment>
    );
  }
);
